<template>
	<div style="height: 100%;">
		<div :style="{padding: '16px',height: '100%',display:topic.Loading?'none':'block'}">
			<div style="height: 30px;font-size: 20px;line-height: 20px;width: 100%;text-align: center;">
				【{{currTopic.ttName}}】<Icon @click="topicRule=true" type="ios-help-circle-outline" />
			</div>
			<Card style="height: 79%;overflow-y:auto;">
				<div class="title">
					{{currTopic.stIndex}}.{{currTopic.stTitle}}
				</div>
				<Row v-for="item in currTopic.answers" @click.native="selectAnswer(item)" :key="item" type="flex" justify="center" align="center" class="topicRow">
					<Col span="2">
						<div :style="{display:item.isSelect==false||(currTopic.ttCount!=1&&(currTopic.isProper==undefined||item.isSelect==false&&item.proper==true))?'block':'none',background:item.isSelect==true?'#ccc':item.proper?'#5cadff':'',color:item.isSelect==true||item.proper==true?'white':'black'}" class="label">{{item.label}}</div>
						<Icon :type="item.isSelect==false||(currTopic.ttCount!=1&&currTopic.isProper==undefined)?'ios-radio-button-off':item.proper?'md-checkmark-circle':'md-close-circle'" :color="item.isSelect==false||(currTopic.ttCount!=1&&currTopic.isProper==undefined)?'#dcdee2':item.proper?'#5cadff':'#ef7a5d'" :size="(currTopic.isProper==undefined)||item.isSelect==false?29:28" class="icon" />
					</Col>
					<Col span="22">
						<div style="text-align: left;padding-left:8px;">
							{{item.content}}
						</div>
					</Col>	
				</Row>
				<Row type="flex" justify="center" align="center" class="topicRow">
					<Col span="6">
					</Col>
					<Col span="12">
						<Button @click="submitAnswer" v-if="currTopic.ttCount!=1&&currTopic.isProper==undefined" type="primary" size="small" long>确认答案</Button>
					</Col>					
					<Col span="6">
					</Col>
				</Row>
				<div v-if="currTopic.isProper!=undefined" style="width: 100%;font-weight: bold;text-align: left;margin-top: 26px;">
					正确答案:{{currTopic.answers.filter(a=>currTopic.stAnswer.indexOf(a.order)!=-1).sort(function(val1,val2){
						return val1-val2;
					}).map(a=>a.label).join('、')}}
				</div>
				<div v-if="currTopic.isProper!=undefined&&currTopic.resolution&&currTopic.resolution.length>0" style="width: 100%;color: #ccc;text-align: left;margin-top: 8px;font-size: 12px;">
					【答案解析】{{currTopic.resolution}}
				</div>
			</Card>
			<Row type="flex" justify="center" align="center" style="margin: 5px 0px;">
				<Col span="20">
					<Progress :percent="topics.filter(t=>t.isProper!=undefined).length*100/topics.length" :hide-info="true" :stroke-width="8" />
				</Col>
				<Col span="4">
					{{topics.filter(t=>t.isProper!=undefined).length}}/{{topics.length}}
				</Col>
			</Row>
			<Row type="flex" justify="center" align="center" style="margin: 12px 0px;">
				<Col span="4">
				</Col>
				<Col span="8">
					<Button type="success" size="small" style="width: 100%;" shape="circle">正确：{{topics.filter(t=>t.isProper==true).length}}</Button>
				</Col>
				<Col span="8">
					<Button type="error" size="small" style="width: 100%;"  shape="circle">错误：{{topics.filter(t=>t.isProper==false).length}}</Button>
				</Col>
				<Col span="4">
				</Col>
			</Row>
			<Row type="flex" justify="center" align="center">
				<Col span="8">
					<Button v-if="currTopicIndex!=0" type="default" @click="currTopicIndex=currTopicIndex>0?--currTopicIndex:currTopicIndex"  style="width: 92%;" >上一题</Button>
				</Col>
				<Col span="8">
					<Button type="default" @click="topicInfo=true" style="width: 92%;margin-left: 5px;" >答题情况</Button>
				</Col>
				<Col span="8">
					<Button v-if="currTopicIndex<topics.length-1" @click="currTopicIndex=currTopicIndex<topics.length?++currTopicIndex:currTopicIndex" type="default"  style="width: 92%;margin-left: 5px;">下一题</Button>
				</Col>
			</Row>
			<Modal
			footer-hide
			:mask-closable="false"
			:styles="{top:'80px'}"
			v-model="topicInfo">
				<div style="height: 18rem;">
					<div style="height: 16rem;width: 100%;padding: 12px;overflow-y:auto ;">
						<div @click="toTopic(item)" v-for="item in topics" style="height: 30px;width: 30px; float:left;position:relative;cursor: pointer;margin-bottom: 6px;">
							<div :style="{display:item.isProper==undefined?'block':'none'}"  class="topicInfo">{{item.stIndex}}</div>
							<Icon :type="item.isProper==undefined?'ios-radio-button-off':item.isProper?'md-checkmark-circle':'md-close-circle'" :color="item.isProper==undefined?'#dcdee2':item.isProper?'#5cadff':'#ef7a5d'" :size="item.isProper==undefined?29:28"/>
							<Icon v-if="item.stIndex==currTopicIndex+1" size="18" style="margin-top: -15px;margin-left: 5px;" type="md-arrow-dropup" />
						</div>
					</div>
					<Row type="flex" justify="center" align="center">
						<Col span="2">
						</Col>
						<Col span="10" style="text-align: center;">
							<Button type="info" icon="md-flag" @click="finishTopic" >答题完毕</Button>
						</Col>
						<Col span="10" style="text-align: center;">
							<Poptip
							confirm="true"
							transfer="true"
								title="确定要放弃作答吗?"
								@on-ok="outTopic"
								@on-cancel="cancel"
								ok-text="对头"
								cancel-text="不干">
								<Button type="dashed" icon="ios-log-out">放弃答题</Button>
							</Poptip>
						</Col>
						<Col span="2">
						</Col>
					</Row>
				</div>
				
			</Modal>
			
			<Modal
			footer-hide
			:mask-closable="false"
			v-model="topicRule">
				<div style="height: 18rem;">
					<Row type="flex" justify="center" align="center">
						<Col span="8">
						</Col>
						<Col span="8" style="text-align: center;font-size: 20px;font-weight: bold;">
							答题提醒
						</Col>
						<Col span="8">
						</Col>
					</Row>
					<div style="height: 12rem;padding-top:1rem;margin-bottom: 2rem;position: relative;">
						<p class="topicRule">1.本次题型分为必答、判断、单选及多选题等四种</p>
						<p class="topicRule">2.必答题每题10分，其他随机题每题5分</p>
						<p class="topicRule">3.答案自动保存,重新进入可继续答题</p>
						<p style="position: absolute;bottom:0px;;color: red;font-size: 14px;">*温馨提示：成绩单图片纯属娱乐，如引起不适，敬表歉意。</p>
					</div>
					<Row type="flex" justify="center" align="center">
						<Col span="8">
						</Col>
						<Col span="8">
							<Checkbox v-model="topicRuleRemind">下次不用提醒</Checkbox>
						</Col>
						<Col span="8">
						</Col>
					</Row>
				</div>
			</Modal>
		</div>
	</div>
</template>
<script>
	export default {
		data(){
			return {
				topic:{
					Loading:true
				},
				topicInfo:false,
				topicRule:false,
				topicRuleRemind:localStorage.topicRuleRemind==undefined?false:true,
				ServerUrl:'https://m.url1.cn/Testing/',
				personTestingInfo:sessionStorage.person?JSON.parse(sessionStorage.person):null,
				topics:[
				],
				currAnswers:[
					
				],
				currTopicIndex:0
			}
		},
		created:function(){
			if(this.personTestingInfo==null){
				this.$router.push('/404');
				return;
			}
			this.$Spin.show({
				render: (h) => {
					return h('div', [
						h('Icon', {
							'class': 'demo-spin-icon-load',
							props: {
								type: 'ios-loading',
								size: 18
							}
						}),
						h('div', '抽题中...')
					])
				}
			});
			this.$axios({
				url:this.ServerUrl+'systestinglibrary/exportTopics?pid='+this.personTestingInfo.pid+'&tid='+this.personTestingInfo.tid,
				method: "GET"
			}).then((res) => {
				let topics=res.data.data.topics;
				for(let i=0;i<topics.length;i++){
					topics[i].stIndex=i+1;
					topics[i].isProper=undefined,
					topics[i].selectAnswers=[];
					for (let index in topics[i].answers) {
						topics[i].answers[index].isSelect=false;
						topics[i].answers[index].proper=undefined;
						if(topics[i].ptStatus=='00'){
							if(topics[i].ptAnswer.indexOf(topics[i].answers[index].order)!=-1){
								topics[i].answers[index].isSelect=true;
								topics[i].selectAnswers.push(topics[i].answers[index].order);
							}
							if(topics[i].stAnswer.indexOf(topics[i].answers[index].order)!=-1){
								topics[i].answers[index].proper=true;
							}
						}
					}
					if(topics[i].selectAnswers.length>0){
						topics[i].isProper=topics[i].selectAnswers.sort(function(val1,val2){
							return val1-val2;
						}).join('')==topics[i].stAnswer;
						this.currTopicIndex=i<topics.length?i+1:i;
					}
				}
				this.topics=topics;
				setTimeout(() => {
					this.$Spin.hide();
					this.topic.Loading=false;
					this.topicRule=localStorage.topicRuleRemind==undefined?true:false;
				}, 1000);
			});
		},
		methods:{
			properAnswer(answer){
				this.currTopic.ptAnswer=answer;
				let arr=this.currTopic.answers.filter(a=>this.currTopic.stAnswer.indexOf(a.order.toString())!=-1);
				for(let i=0;i<arr.length;i++){
					arr[i].proper=true;
				}
				this.currTopic.isProper=this.currTopic.stAnswer==answer;
				this.uploadTopic(this.currTopic);
			},
			submitAnswer(){
				if(this.currTopic.isProper==undefined){
					if(this.currTopic.selectAnswers.length<this.currTopic.ttCount){
						this.$Message.warning({content:'请选择至少两个答案',duration:3});
						return ;
					}
					this.properAnswer(this.currTopic.selectAnswers.sort(function(val1,val2){
						return val1-val2;
					}).join(''));
				}
			},
			selectAnswer(item){
				if(this.currTopic.isProper==undefined){
					item.isSelect=true;
					if(this.currTopic.ttCount==1){
						this.properAnswer(item.order);
					}else if(this.currTopic.selectAnswers.indexOf(item.order.toString())!=-1){
						for(let i=0;i<this.currTopic.selectAnswers.length;i++){
							if(this.currTopic.selectAnswers[i]==item.order.toString()){
								this.currTopic.selectAnswers.splice(i,1);
								item.isSelect=false;
								break;
							}
						}
					}else{
						this.currTopic.selectAnswers.push(item.order.toString());
					}
				}
			},
			toTopic(item){
				this.currTopicIndex=item.stIndex-1;
				this.topicInfo=false;
			},
			uploadTopics(){
				this.uploadLoad=true;
				let arr=this.updateAnswer('00');
				this.$axios({
					url:this.ServerUrl+'persontesting/submitAnswers',
					method: "POST",
					data:arr
				}).then((res) => {
					if(res.code=='200'){
						this.$Message.info('上传成功');
						this.uploadLoad=false;
						this.topicInfo=false;
						return ;
					}
					this.$Message.error(res.msg);
				});
				
			},
			uploadTopic(item){
				let ptTemp={
					ptId:item.ptId,
					ptAnswer:item.ptAnswer,
					ptStatus:'00'
				};
				this.$axios({
					url:this.ServerUrl+'persontesting/submitAnswer',
					method: "POST",
					data:ptTemp
				}).then((res) => {
					if(res.data.code!='200'){
						this.$Message.error({content:'系统异常！请与管理员联系',duration:3});
						return ;
					}
				});
			},
			finishTopic(){
				if(this.topics.filter(t=>t.isProper!=undefined).length<this.topics.length){
					this.$Modal.warning({
                            title: '亲，您的题还未作答',
							styles:{'margin-top':'300px'}
                     });
					 return ;
				}
				this.$Spin.show({
					render: (h) => {
						return h('div', [
							h('Icon', {
								'class': 'demo-spin-icon-load',
								props: {
									type: 'ios-loading',
									size: 18
								}
							}),
							h('div', '正在出成绩单...')
						])
					}
				});
				setTimeout(() => {
					this.$Spin.hide();
					let gradeArr=this.topics.filter(t=>t.isProper==true).map(t=>t.stGrade);
					let sum=0;
					for(let index in gradeArr){
						sum+=parseInt(gradeArr[index]);
					}
					this.personTestingInfo.grade=sum;
					sessionStorage.person=JSON.stringify(this.personTestingInfo);
					this.$router.push({name:'Result'});
				}, 2000);
			},
			outTopic(){
				let arr=this.updateTopic('04');
				this.$axios({
					url:this.ServerUrl+'persontesting/submitAnswers',
					method: "POST",
					data:arr
				}).then((res) => {
					if(res.data.code=='200'){
						this.$Message.info({content:'操作成功！3秒后跳转至活动页面',duration:3});
					}else{
						this.$Message.error(res.data.msg);
					}
					this.topicInfo=false;
					sessionStorage.person=JSON.stringify(this.personTestingInfo);
					let router=this.$router;
					setTimeout(function(){
						router.push({name:'Testing'});
					},3000);
				});
			},
			updateTopic(ptStatus){
				let arr=[];
				for(let i=0;i<this.topics.length;i++){
					let obj={
						ptId:this.topics[i].ptId,
						ptAnswer:this.topics[i].ptAnswer==undefined?'':this.topics[i].ptAnswer,
						ptStatus:ptStatus
					};
					arr[i]=obj;
				}
				return arr;
			}
		},
		computed:{
			currTopic:function(){
				return this.topics[this.currTopicIndex];
			}
		},
		watch:{
			topicRuleRemind:{
				handler:function(curVal){
					if(curVal){
						localStorage.topicRuleRemind='1';
					}else if(localStorage.topicRuleRemind){
						localStorage.removeItem('topicRuleRemind');
					}
	　　　　　　 },
				deep: true
			}
		}
	}
</script>
<style>
	.label{
		width: 23px;
		height: 23px;
		border-radius: 12px;
		position: absolute;
		text-align: center;
		left: 3px;
		top: 3px;
	}
	
	.icon{
		position: absolute;
		left: 0px;
		top: 0px;
		cursor: pointer;
	}
	.topicRow{
		margin-bottom: 18px;
		
	}
	.title{
		text-align: left;
		font-size: 16px;
		font-weight: bold;
		margin-bottom: 12px;
	}
	
	.topicInfo{
		background: #dcdee2;
		color: white;
		text-align: center;
		line-height: 24px;
		height: 24px;
		width: 24px;
		border-radius: 13px;
		position: absolute;
		left: 2px;
		top: 2px;
	}
	
	.topicRule{
		font-size: 16px;
	}
	
	.demo-spin-icon-load{
        animation: ani-demo-spin 1s linear infinite;
    }
</style>


// WEBPACK FOOTER //
// src/components/views/WeChat/Person/Testing/Topic/index.vue